import { fetchWrapper } from "@/helpers/fetchWrapper";

const ruta = process.env.VUE_APP_ROOT_API;

export default class ReporteInsumoService {
  /**
   * Obtiene el listado de insumos con stock paginado/filtrado
   */
  async getInsumosStock(params) {
    const cleanedParams = {};
    for (const key in params) {
      if (params[key] !== null && params[key] !== undefined && params[key] !== "") {
        cleanedParams[key] = params[key];
      }
    }
    const query = new URLSearchParams(cleanedParams).toString();
    return await fetchWrapper.get(`${ruta}/reportes/insumos-stock?${query}`);
  }

  /**
   * Exporta a Excel (.xlsx) usando el blob helper
   */
  async exportExcel(datos) {
    return await fetchWrapper.postWithBlob(`${ruta}/reportes/insumos-stock/excel`, datos);
  }

  /**
   * Genera el PDF usando el helper de impresión
   */
  async exportPdf(datos) {
    return await fetchWrapper.postPdf(`${ruta}/reportes/insumos-stock/pdf`, datos);
  }
}
